<template>
    <b-row>
        <b-col md="12">
            <b-card
                no-body
            >
                <div class="card-header">
                    <div
                        class="card-group-title"
                    >
                        <feather-icon
                            icon="StarIcon"
                            size="17"
                            class="text-warning mr-50"
                        />
                        {{ $t('org.common.Notice') }}
                    </div>
                </div>
                <b-table
                    responsive
                    :fields="fields"
                    :items="boardDocuments"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @filtered="onFiltered"
                >
                    <template #cell(subject)="{ item }">
                        <router-link :to="`/notices/${item.service}/${item.timestamp}`">
                            {{ item.subject }}
                        </router-link>
                    </template>
                </b-table>
                <div class="card-body d-flex justify-content-between flex-wrap pt-0">
                    <!-- page length -->
                    <b-form-group
                        label="Per Page"
                        label-cols="6"
                        label-align="left"
                        label-size="sm"
                        label-for="sortBySelect"
                        class="text-nowrap mb-md-0 mr-1"
                    >
                        <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
                    </b-form-group>

                    <!-- pagination -->
                    <div>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            first-number
                            last-number
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mb-0"
                        >
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import { getCurrentInstance, computed, ref, watch } from '@vue/composition-api'
export default {
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const loading = ref(true)
        const filterOn = ref(['service', 'subject'])
        const fields = [
            {
                label: 'Service',
                key: 'service',
                tdClass: ['text-capitalize'],
                sortable: false
            },
            {
                label: 'Subject',
                key: 'subject',
                sortable: false
            },
            {
                label: 'Time Created',
                key: 'timestamp',
                sortable: false,
                formatter: (value, key, item) => {
                    return new Date(value * 1).toLocaleDateString()
                }
            }
        ]
        const boardDocuments = computed(() => store.getters.boardDocuments)
        const boardDocument = computed(() => store.getters.boardDocument)
        const filter = ref('')
        const currentPage = ref(1)
        const totalRows = ref(boardDocuments.value.length)
        const perPage = ref(10)
        const pageOptions = [10, 20, 100]
        const onFiltered = (filteredItems) => {
            totalRows.value = filteredItems.length
            currentPage.value = 1
        }
        const getBoardDocuments = () => store.dispatch('getBoardDocuments')
        const getBoardDocument = (document) => store.dispatch('getBoardDocument', { timestamp: document.timestamp, service: document.service })
        if (!boardDocuments.value.length) {
            getBoardDocuments()
        }
        watch(boardDocuments, (value) => {
            totalRows.value = value.length
        })
        return {
            fields,
            filterOn,
            filter,
            currentPage,
            totalRows,
            perPage,
            pageOptions,
            onFiltered,
            loading,
            boardDocuments,
            boardDocument,
            getBoardDocument
        }
    }
}
</script>

<style>

</style>
